import React from 'react'
import { useFormContext } from 'react-hook-form'
import { FormattedMessage } from 'react-intl'

import { HouseStudyDayIndividualDto } from '../../../../../../../../../../../lib/graphql'
import { ControlledTextField } from '../../../../../../../../../../forms'
import { HouseStudyDayIndividualFieldProps } from '../../../form-container/HouseStudyDayIndividualFormContainer'

export const HouseStudyDayIndividualCapacityFields = ({
  control,
  isFieldDisabled,
}: Omit<HouseStudyDayIndividualFieldProps, 'currencyArea'>) => {
  const fieldProps = {
    disabled: isFieldDisabled,
    control,
    type: 'number',
    inline: true,
    rules: { required: 'Champ requis.' },
    placeholder: '0',
  }

  const { watch } = useFormContext<HouseStudyDayIndividualDto>()

  const minCapacity = watch('options.capacity.min')

  return (
    <>
      <ControlledTextField
        {...fieldProps}
        name='options.capacity.min'
        label={
          <FormattedMessage
            id='ui.HouseStudyDayIndividualFormFields.options.minCapacity'
            defaultMessage=' Nombre <bold>minimum</bold> de participants'
            values={{ bold: (content) => <b>{content}</b> }}
          />
        }
      />

      <ControlledTextField
        {...fieldProps}
        name='options.capacity.max'
        rules={{
          ...fieldProps.rules,
          validate: (value: string) => {
            // MaxCapacity should be greater than or equal to MinCapacity
            const hasError = Number(value) < minCapacity

            return !hasError
          },
        }}
        label={
          <FormattedMessage
            id='ui.HouseStudyDayIndividualFormFields.options.maxCapacity'
            defaultMessage=' Nombre <bold>maximum</bold> de participants'
            values={{ bold: (content) => <b>{content}</b> }}
          />
        }
      />
    </>
  )
}
